import { EnumMovModelo } from "model/enums";

export class RetiradaDocumentoPostModel {
    constructor(
        public mod: Array<Number> | undefined = [EnumMovModelo.NFCE,EnumMovModelo.NFE,EnumMovModelo.SAT],
        public status: Array<Number> = [2],
        public dInicial: string = '',
        public dFinal: string = '',
    ) { }
}